import React from 'react';
import {withStyles, Switch, Grid} from '@material-ui/core';
import {Translate} from '../../../config/TranslationProvider';

const AntSwitch = withStyles((theme) => ({
    root: {
        width: 28,
        height: 16,
        padding: 0,
        display: 'flex',
    },
    switchBase: {
        padding: 2,
        color: theme.palette.grey[500],
        '&$checked': {
            transform: 'translateX(12px)',
            color: theme.palette.common.white,
            '& + $track': {
                opacity: 1,
                backgroundColor: '#290',
                borderColor: '#290',
            },
        },
    },
    thumb: {
        width: 12,
        height: 12,
        boxShadow: 'none',
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
    },
    checked: {},
}))(Switch);

const SwitchGrid = withStyles(() => ({
    container: ({row, disabled}) => ({
        justifyContent: 'left',
        background: '#fff',
        color: '#000',
        padding: '0.33333rem', // 5px
        borderRadius: '5px',
        position: 'absolute',
        top: (0.66666 /* 10px */ + 2.66666 * (row - 1)) + 'rem',
        right: '0.66666rem',
        zIndex: 100,
        width: '315px',
        boxShadow: '0 1px 5px rgba(0,0,0,0.65)',
        cursor: disabled ? 'not-allowed' : null,
    }),
}))(Grid);

const LoadOtherResourcesSwitch = ({
    showOtherResources,
    setShowOtherResources,
    translationKey,
    row = 1,
    disabled = false,
}) => {

    const handleChange = event => {
        event.preventDefault();
        setShowOtherResources(!showOtherResources);
    };

    return (
        <SwitchGrid component="label" container alignItems="center" row={row} disabled={disabled}>
            <Grid item style={{margin: '0 5px'}}>
                <AntSwitch
                    name="showOtherResources"
                    checked={showOtherResources}
                    onChange={handleChange}
                    disabled={disabled}
                />
            </Grid>
            <Grid item style={{margin: '0 5px'}}>
                <Translate value={translationKey} />
            </Grid>
        </SwitchGrid>
    );
};

export default LoadOtherResourcesSwitch;
